<template>
    <div class="rr-builder-modal uk-modal-container" uk-modal>
        <div method="POST" action="http://rubinred.test" class="rr-builder-modal__dialog uk-modal-dialog">
            <div class="rr-builder-modal__header uk-modal-header">
              <h2 class="rr-builder-modal__title uk-modal-title">
                {{ $t('rubinred.content.builder.cloneLanguageModal.title', primaryLocale) }}
              </h2>
            </div>
            <div class="uk-modal-body" ref="templatesList">
              <select v-model="selectedLanguage" class="uk-input">
                <option v-for="item in availableLanguages" :value="item.key">{{ item.label }}</option>
              </select>
            </div>
            <div class="rr-builder-modal__footer rr-builder-modal__footer_first-left uk-modal-footer uk-text-right">
              <button type="button" class="uk-button uk-button-default uk-modal-close">
                {{ $t('rubinred.content.builder.cloneLanguageModal.cancel', primaryLocale) }}
              </button>
              <button type="submit" class="uk-button uk-button-primary" @click="clone">
                {{ $t('rubinred.content.builder.cloneLanguageModal.save', primaryLocale) }}
              </button>
            </div>
          <a class="rr-builder-modal__close uk-modal-close-default" uk-close></a>
        </div>
    </div>
</template>

<script>
  import PrimaryLocaleAwareComponent from "rubinred/content/js/mixins/PrimaryLocaleAwareComponent";

  export default {
    mixins: [PrimaryLocaleAwareComponent],
    props: {
      availableLanguages: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        selectedLanguage: '',
      }
    },

    created() {
      this.$root.$on('open-clone-language-modal', this.show);
      this.$root.$on('close-clone-language-modal', this.hide);
    },

    mounted() {
      this.modal = window.App.UIkit.modal(this.$el);
    },

    methods: {
      show() {
        this.modal.show();
      },
      clone() {
        this.$root.$emit('do-clone-language', this.selectedLanguage);
        this.modal.hide();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/content/assets/js/components/BuilderCloneLanguageModal.vue